module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/lang/whitelist_en.json
// module id = 141
// module chunks = 0